import React from 'react';
import image from '../../assets/customersoftware.png';
import ServiceTech from '../../component/servicetech'
import bpsheader from '../../assets/bpsheader.jpg';
import bpskey1 from '../../assets/bps1.jpg';
import bpskey2 from '../../assets/bps2.jpg';
import bpskey3 from '../../assets/bps3.jpg';
const Bps = () => {
  const data =  {
    "headerimg":bpsheader,
    "key1img":bpskey1,
    "key2img":bpskey2,
    "key3img":bpskey3,
    "maintitle":"Efficiency is the foundation of success—streamline today for a more productive tomorrow",
    "mainsub":"Transforming Business Processes for Maximum Impact",

    "title":"Business Process Services",
    "subtext":"Our Business Process Services (BPS) optimize your workflows, reduce operational costs, and boost overall efficiency. We tailor our solutions to your business requirements, allowing you to focus on core competencies while we handle the rest. With our BPS expertise, your business can achieve operational excellence and drive continuous improvement across all functions.",
    "choose1":"We provide tailored BPS solutions aimed at streamlining operations, cutting costs, and boosting productivity. Our customized services empower your business to concentrate on core competencies while we handle the complexities. By leveraging our expertise, you can enhance efficiency and achieve sustainable growth, ensuring your organization stays competitive in today’s market.",
    "choose2":"Our BPS specialists possess extensive experience across various industries. They deeply understand your processes, enabling them to deliver effective and scalable solutions tailored to your unique needs. By focusing on the intricacies of your operations, we ensure that our strategies align perfectly with your organizational goals and objectives.",
    "choose3":"Our services leverage powerful data analytics to provide you with real-time insights. These insights empower you to optimize workflows, streamline operations, and make informed business decisions. With our support, you can drive sustainable growth and enhance operational efficiency, ensuring that your organization remains competitive in an ever-evolving market landscape.",
    "key1":"Process Efficiency",
    "key2":"Cost Reduction",
    "key3":"Data-Driven Decision Making",
    "key4":"Flexibility and Scalability",
    "key5":"Business Innovation",
    "text1":"Optimize business processes through tailored BPS solutions, reducing operational overhead, enhancing service quality, and increasing overall business agility.",
    "text2":"BPS enables companies to cut costs by streamlining workflows and improving resource utilization, allowing businesses to focus on their core competencies while improving operational efficiency",
    "text3":"BPS leverages data analytics to provide insights that drive smarter business decisions, ensuring processes are aligned with long-term strategic goals",
    "text4":"As business needs evolve, BPS solutions are flexible and scalable, adapting to changes while maintaining high levels of service quality and operational efficiency",
    "text5":"Outsourcing specific business processes reduces operational risks and ensures compliance with industry standards, allowing businesses to mitigate regulatory and financial risks effectively.",
    "text6":"With our expertise in Business Process Services (BPS), organizations can rethink, re-engineer, and streamline their processes for improved operational performance and agility."




}

  return (

 

  <>
    <ServiceTech values={data} />
  </>

    
 
)
};

export default Bps;
